import { render, staticRenderFns } from "./MeasurementInstructions.vue?vue&type=template&id=64906fc4&"
import script from "./MeasurementInstructions.vue?vue&type=script&lang=js&"
export * from "./MeasurementInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports